import React from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CardActionArea from "@mui/material/CardActionArea";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { DISCOVERY_CARD_SX } from "/imports/ui/components/discovery";

function IntentCard({ icon: Icon, title, blurb, onClick }) {
  return (
    <Box
      sx={{
        ...DISCOVERY_CARD_SX,
        height: "100%",
        overflow: "hidden",
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
        "&:hover": { transform: "translateY(-2px)", boxShadow: "0 10px 28px rgba(26,26,26,0.08)", borderColor: "primary.main" }
      }}
    >
      <CardActionArea
        onClick={onClick}
        // On a phone the blurb and the Continue row are hidden, leaving an icon
        // over a single line — a launcher tile, which centres. Desktop keeps the
        // left edge, where the blurb below it gives the text a column to sit in.
        sx={{
          p: { xs: 1.75, md: 3 },
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: { xs: "center", md: "flex-start" },
          textAlign: { xs: "center", md: "left" }
        }}
      >
        <Box
          sx={{
            width: { xs: "2.5rem", md: "3.25rem" },
            height: { xs: "2.5rem", md: "3.25rem" },
            borderRadius: 2,
            bgcolor: (t) => alpha(t.palette.primary.main, 0.12),
            color: "primary.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: { xs: 1, md: 1.75 }
          }}
        >
          <Icon sx={{ fontSize: { xs: "1.375rem", md: "1.75rem" } }} />
        </Box>
        <Typography fontWeight={700} sx={{ letterSpacing: "-0.01em", fontSize: { xs: "0.95rem", md: "1.25rem" }, lineHeight: 1.3 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, display: { xs: "none", md: "block" } }}>
          {blurb}
        </Typography>
        <Box sx={{ flex: 1 }} />
        <Box
          sx={{
            display: { xs: "none", md: "inline-flex" },
            alignItems: "center",
            gap: 0.5,
            mt: 2,
            color: "primary.main",
            fontWeight: 600,
            fontSize: "0.875rem"
          }}
        >
          Continue <ArrowForwardIcon sx={{ fontSize: "1rem" }} />
        </Box>
      </CardActionArea>
    </Box>
  );
}

export default IntentCard;
